import { useAccount, useReadContract } from "wagmi";
import { useMemo } from "react";
import { StakingManagerAbi, contractAddresses } from "@meta";
import { formatUnits } from "viem";
import { useStEthRewards } from "../chi/useStEthRewards";

export const useGetStakedEthRewards = () => {
  const { address } = useAccount();

  const { data: uscEthData } = useReadContract({
    abi: StakingManagerAbi,
    functionName: "getUserTotalRewardsForToken",
    address: contractAddresses.StakingManager,
    args: [address!, contractAddresses.USC_ETH_LP, contractAddresses.stETH],
  });

  const { data: chiEthData } = useReadContract({
    abi: StakingManagerAbi,
    functionName: "getUserTotalRewardsForToken",
    address: contractAddresses.StakingManager,
    args: [address!, contractAddresses.CHI_ETH_LP, contractAddresses.stETH],
  });

  const { totalStETHRewardsDSPL } = useStEthRewards();

  // Calculate the sum using useMemo for optimization
  const sum = useMemo(() => {
    const uscEthRewards = uscEthData || 0n;
    const chiEthRewards = chiEthData || 0n;
    const totalStEthRewards = totalStETHRewardsDSPL?.originalValue || 0n;
    return formatUnits(uscEthRewards + chiEthRewards + totalStEthRewards, 18);
  }, [uscEthData, chiEthData]);

  return {
    sum,
    uscEthData: {
      formattedUscEthData: formatUnits(uscEthData || 0n, 18),
      uscEthData: uscEthData || 0n,
    },
    chiEthData: {
      formattedChiEthData: formatUnits(chiEthData || 0n, 18),
      chiEthData: chiEthData || 0n,
    },
  };
};
